module.exports = __webpack_public_path__ + "media/images/campo-de-futebol-b0661c8fddcb53fb9f879f6000ae8de8.png";